(function () {
  if (window.__hlCartRelated) return;
  window.__hlCartRelated = true;

  /* A small horizontal rail of related products, above the discount block in the
     cart drawer. Owner, 2026-09-12: "Thêm các related products ở trên discount
     code, nhỏ thôi (nằm ngang, scroll ngang thôi, tự động load thêm khi user add
     to cart 1 món khác)".

     THIS IS NOT hl-cart-upsell COMING BACK. That snippet is still on the theme
     and still stood down; it carries a bundle-progress line and, more to the
     point, a QUICK-VIEW SHEET. The sheet is the surface that produced the worst
     defect this project has found — a variant picker inside it driving the PAGE's
     product into the cart — and hl-sticky-cart's hlIsPagePicker() exists only to
     stop that. Nothing here opens a sheet, so that whole class of bug cannot
     occur; see the note on card() for what a card does instead.

     THREE THINGS THAT COST THIS PROJECT TIME AND ARE DESIGNED FOR HERE:

     1. THE OBSERVER FEEDBACK LOOP. The earlier rail cleared and re-appended its
        cards on every refresh, unconditionally, while hl-cart-polish rewrote its
        tier ladder on every pass; each one's writes woke the other's observer and
        an open, untouched drawer issued 11 /cart.js requests per 15 idle seconds
        against live's 0. hl-cart-polish is gone, but the trigger the owner is
        asking for — refresh when another item is added — is the same trigger that
        fed it. So: the rail rebuilds ONLY when the list of product ids changes
        (`rail.dataset.hlKey`), and the observer below ignores anything inside our
        own wrapper.

     2. NOTHING FETCHES /cart.js. The seed used to come from a /cart.js read on
        every refresh. It comes from the drawer's own DOM now — the line items are
        links to /products/<handle> — so the count cart_idle_test watches is
        structurally zero rather than merely small. Product ids are resolved once
        per handle from /products/<handle>.js and cached for the session.

     3. NO VISUALLY-HIDDEN TEXT INSIDE THE SCROLLER. A visually-hidden <span>
        placed in a horizontal scroller on this store once took body.scrollWidth
        from 433 to 2972: off-screen text is still laid out, and in a flex row it
        is laid out sideways. Every name here is an attribute. */

  /* COMBINED PRODUCTS ONLY, 2026-10-21. Owner: "you may also like hãy show combined
     products (nếu k có combined thì k show card này)", together with "relate cart
     không giống call to action lắm nhìn k biết click đâu ... kiểu k chuẩn layout và
     phức tạp, ít thông tin".

     So the rail no longer asks /recommendations (complementary, then related, then a
     second intent on scroll). It shows the merchant's own pairing for what is in the
     cart — custom.combined_products, the list behind "Pairs well with this" on the
     PDP — read through templates/product.hl-cp.liquid. A cart whose products have no
     pairing shows nothing here at all.

     And it is no longer a horizontal strip with an icon laid over the photo. Most
     products carry one to three pairings, so the rail is a short list of rows, the
     PDP's combined card in the drawer's type: photo, name, rating, price, and ONE
     labelled button at the end of the row ("Add", or "Select" when there is a size
     or colour to choose). Tapping the photo or the name opens the product sheet. */
  var CARDS = 3;
  /* Drawn here rather than pulled from an icon sheet: this file has to work with
     no other hl-* snippet rendered. */
  var ICON_PLUS = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8"'
    + ' stroke-linecap="round" aria-hidden="true"><path d="M10 4.5v11M4.5 10h11"/></svg>';
  var ICON_GONE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"'
    + ' stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  var busy = false;
  var pending = false;

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US',
        { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* THE EMPTY CART GETS A GALLERY (2026-10-01). Recommendations are SEEDED by a product in the
     cart, so with nothing in it the rail has nothing to ask about. The owner's call: do not copy the
     rail there; show a plain gallery of the store's best sellers instead -- the one moment a shopper
     has opened the cart and has nothing in it is when something to look at is most useful. */
  var emptyCache = null;
  function isEmptyDrawer(drawer) { return !!drawer.querySelector('.cart-drawer--empty'); }

  /* /collections/<x>/products.json speaks dollars-as-strings and {images:[{src}]}; card() speaks the
     /recommendations shape (cents, featured_image, available). Convert once, here. */
  function cents(v) { var n = parseFloat(v); return isFinite(n) ? Math.round(n * 100) : 0; }
  function asRec(p) {
    var vs = p.variants || [];
    var prices = vs.map(function (v) { return cents(v.price); }).filter(Boolean);
    var was = vs.map(function (v) { return v.compare_at_price ? cents(v.compare_at_price) : 0; }).filter(Boolean);
    var lo = prices.length ? Math.min.apply(null, prices) : 0;
    var hi = prices.length ? Math.max.apply(null, prices) : 0;
    var img = p.images && p.images[0] && p.images[0].src || '';
    return {
      id: p.id, handle: p.handle, title: p.title,
      featured_image: img,
      images: (p.images || []).map(function (i) { return i.src; }),
      price: lo, price_min: lo, price_max: hi,
      compare_at_price_min: was.length ? Math.min.apply(null, was) : null,
      available: vs.some(function (v) { return v.available; }),
      variants: vs.map(function (v) { return { id: v.id, available: v.available }; })
    };
  }
  function getJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; });
  }
  function fetchEmptyPool() {
    if (emptyCache) return Promise.resolve(emptyCache);
    return getJson('/collections/best-sellers/products.json?limit=16').then(function (d) {
      var list = (d.products || []).map(asRec);
      if (list.length >= 4) return list;
      /* a thin collection is topped up from the whole catalogue, deduped */
      return getJson('/collections/all/products.json?limit=16').then(function (a) {
        var seen = {}; list.forEach(function (p) { seen[p.id] = 1; });
        (a.products || []).forEach(function (p) { if (!seen[p.id]) list.push(asRec(p)); });
        return list;
      });
    }).then(function (list) { emptyCache = list; return list; });
  }

  var galBox = null, galBusy = false;
  var GAL_MAX = 8;
  function removeGallery() {
    if (galBox && galBox.isConnected) {
      var host = galBox.parentNode;
      galBox.remove();
      if (host && host.classList) host.classList.remove('hl-has-gal');
    }
  }
  function galCard(p) {
    var img = p.featured_image || '';
    var w1 = '', w2 = '';
    if (img) {
      var sep = img.indexOf('?') === -1 ? '?' : '&';
      w1 = img + sep + 'width=360';
      w2 = img + sep + 'width=720';
    }
    var lo = p.price_min != null ? p.price_min : p.price;
    var hi = p.price_max != null ? p.price_max : p.price;
    var price = hi > lo ? 'From ' + money(lo) : money(lo);
    var was = p.compare_at_price_min;
    var wasHtml = (was != null && was > lo) ? '<s class="hl-gal__was">' + money(was) + '</s> ' : '';
    var a = el('a', 'hl-gal__card');
    a.href = '/products/' + p.handle;
    a.innerHTML =
      '<span class="hl-gal__img">' +
        (img ? '<img src="' + w1 + '" srcset="' + w1 + ' 360w, ' + w2 + ' 720w" sizes="(min-width: 750px) 220px, 44vw"'
             + ' alt="" loading="lazy" width="360" height="360">' : '') +
      '</span>' +
      '<span class="hl-gal__title"></span>' +
      '<span class="hl-gal__price">' + wasHtml + '<span class="hl-gal__now">' + price + '</span></span>';
    a.querySelector('.hl-gal__title').textContent = p.title;
    a.setAttribute('aria-label', p.title + ', ' + price);
    return a;
  }
  function renderGallery(drawer) {
    var content = drawer.querySelector('.cart-drawer--empty .cart-drawer__content');
    if (!content) return;
    if (!galBox) {
      galBox = el('section', 'hl-gal');
      galBox.hidden = true;
      galBox.innerHTML = '<p class="hl-gal__h" id="hl-gal-h">Best sellers</p><div class="hl-gal__grid" role="list" aria-labelledby="hl-gal-h"></div>';
    }
    if (galBox.parentNode !== content) content.appendChild(galBox);
    content.classList.add('hl-has-gal');
    if (galBox.dataset.ready === '1') { galBox.hidden = false; return; }
    if (galBusy) return;
    galBusy = true;
    fetchEmptyPool().then(function (list) {
      var items = (list || []).filter(function (p) { return p.available; }).slice(0, GAL_MAX);
      if (!items.length) { galBox.hidden = true; return; }
      var grid = galBox.querySelector('.hl-gal__grid');
      grid.innerHTML = '';
      items.forEach(function (p) { var c = galCard(p); c.setAttribute('role', 'listitem'); grid.appendChild(c); });
      galBox.dataset.ready = '1';
      galBox.hidden = false;
    }).catch(function () {}).then(function () { galBusy = false; });
  }

  /* The handles in the drawer, in order, read off the line items' own links. */
  function cartHandles(drawer) {
    var out = [];
    var links = drawer.querySelectorAll('.cart-items__title[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var m = links[i].getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m && out.indexOf(m[1]) === -1) out.push(m[1]);
    }
    return out;
  }


  /* handle -> its available combined products (the hl-cp view), cached for the page. */
  var cpCache = {};
  function fetchCombined(handle) {
    if (cpCache[handle]) return Promise.resolve(cpCache[handle]);
    /* No Accept: application/json — with it Shopify answers /products/<handle> with
       its own product JSON and ignores ?view. */
    return fetch('/products/' + handle + '?view=hl-cp')
      .then(function (r) { return r.ok ? r.text() : '[]'; })
      .then(function (t) {
        var list; try { list = JSON.parse(t); } catch (e) { list = []; }
        cpCache[handle] = Array.isArray(list) ? list : [];
        return cpCache[handle];
      })
      .catch(function () { return []; });
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }


  /* A ROW: the product (a link that opens the sheet) and one button.

     THE LINK. Clicking the photo or the name opens hl-blog-pdp-modal over the
     drawer — the real /products/<handle> markup with its real variant picker — at
     half height. The href stays real: if the modal is missing or reports it could
     not render, the browser follows the link to the product page.

     THE BUTTON. A sibling of the link (a <button> inside an <a> is invalid) and the
     only control on the row, with its word on it. "Add" when there is nothing to
     choose: it adds that variant straight to the cart. "Select" when the product
     has a size or a colour: it opens the same sheet, because a button that says Add
     and does not add is the worst version of this control. */
  function openSheet(p, href) {
    var pdp = window.HLBlogPDP;
    var go = function () { window.location.href = href; };
    if (!pdp || typeof pdp.open !== 'function') { go(); return; }
    try {
      Promise.resolve(pdp.open(p.handle, { title: p.full || p.title, half: true })).then(function (ok) {
        if (ok === false) go();
      }, go);
    } catch (err) { go(); }
  }

  function card(p) {
    var wrap = el('div', 'hl-rel-card');
    wrap.setAttribute('role', 'listitem');
    wrap.dataset.handle = p.handle;

    /* The view hands over the 180 rung of the `thumb` ENUM (hl-img-enum.liquid);
       90 is the 1x rung for this 64px box. */
    var w2 = p.img || '', w1 = w2 ? w2.replace(/([?&])width=180/, '$1width=90') : '';

    /* A range is said as one ("From $29") — a $29 card that opens to $59 reads as
       bait. The struck price only when it is real, higher, and the price is single. */
    var ranged = p.max > p.min;
    var price = ranged ? 'From ' + money(p.min) : money(p.price);
    var wasHtml = (!ranged && p.was > p.price)
      ? '<s class="hl-rel-card__was">' + money(p.was) + '</s>' : '';
    var rateHtml = p.rating
      ? '<span class="hl-rel-card__meta"><b>&#9733; ' + (+p.rating).toFixed(1) + '</b>' +
        (p.count ? ' (' + p.count + ')' : '') + '</span>' : '';

    var a = el('a', 'hl-rel-card__link');
    a.href = '/products/' + p.handle;
    a.innerHTML =
      '<span class="hl-rel-card__img">' +
        (w2 ? '<img src="' + w1 + '" srcset="' + w1 + ' 1x, ' + w2 + ' 2x"'
            + ' alt="" loading="lazy" width="64" height="64">' : '') +
      '</span>' +
      '<span class="hl-rel-card__text">' +
        '<span class="hl-rel-card__title"></span>' + rateHtml +
        '<span class="hl-rel-card__price">' + wasHtml +
          '<span class="hl-rel-card__now">' + price + '</span></span>' +
      '</span>';
    a.querySelector('.hl-rel-card__title').textContent = p.title;
    a.setAttribute('aria-label', p.title + ', ' + price);
    /* the product markup starts loading when the finger lands, not when it lifts */
    a.addEventListener('pointerdown', function () {
      var pdp = window.HLBlogPDP;
      if (pdp && typeof pdp.prefetch === 'function') pdp.prefetch(p.handle);
    }, { passive: true });
    a.addEventListener('click', function (e) {
      if (!window.HLBlogPDP || typeof window.HLBlogPDP.open !== 'function') return;  // a plain link
      e.preventDefault();
      openSheet(p, a.href);
    });
    wrap.appendChild(a);

    var single = !p.choose && p.variant;
    var btn = el('button', 'hl-rel-add');
    btn.type = 'button';
    btn.setAttribute('aria-label', (single ? 'Add ' : 'Select options for ') + p.title);
    btn.innerHTML = (single ? ICON_PLUS : '') + '<span class="hl-rel-add__t">' + (single ? 'Add' : 'Select') + '</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!single) { openSheet(p, a.href); return; }
      if (btn.disabled) return;
      btn.disabled = true;
      /* Same spinner as every other add-to-cart (snippets/hl-atc-busy), until the
         line is in the cart; done()/failed() replace the button's contents. */
      btn.setAttribute('data-hl-atcb', '1');
      var spin = document.createElement('span'); spin.className = 'hl-atcb__spin'; spin.setAttribute('aria-hidden', 'true');
      btn.appendChild(spin);
      addToCart(p.variant, btn);
    });
    wrap.appendChild(btn);
    return wrap;
  }

  /* ADDING FROM A CARD HAS TO REDRAW THE DRAWER, and /cart/add.js on its own
     does not: it changes the cart, while Horizon re-renders
     .cart-drawer__inner only from responses to its OWN section requests. That
     was measured earlier in the week — a bare add left the line items and the
     total a step behind, which is why this file's cards were links only until
     the owner asked for a button.

     The Cart AJAX API answers that: `sections` on the add request returns the
     rendered section, and swapping .cart-drawer__inner is what the theme does
     with it. The dialog itself is not replaced, so the drawer stays open and
     the custom elements inside re-initialise on connect.

     THE JUST-ADDED PRODUCT DROPS OUT OF THE RAIL, and not by a special case:
     the redraw gives the drawer a new line item, render() reads handles off the
     line items, and the filter already excludes anything whose handle is in the
     cart. The seed moves to the product just added, so the next four
     suggestions are its complements. That is the same path as adding from a
     product page, which is what the owner asked the rail to follow.

     IT CANNOT RESTART THE /cart.js LOOP. Nothing here reads /cart.js at all,
     and the redraw only causes a rebuild if the product-id list actually
     changes (rail.dataset.hlKey). cart_idle_test holds this at 0 requests in 15
     idle seconds. */
  function addToCart(variantId, btn) {
    /* THE SAME PATH AS THE PRODUCT PAGE, 2026-09-23. The theme's product form
       dispatches a CartLinesUpdateEvent whose promise resolves with the section
       HTML; cart-items-component then morphs the drawer and animates the new
       row. Doing the same here — instead of swapping .cart-drawer__inner — is
       what makes a rail add look like any other add, and it also updates the
       header count and anything else listening for the theme's event. */
    var unspin = function () {
      btn.removeAttribute('data-hl-atcb');
      var s = btn.querySelector('.hl-atcb__spin'); if (s) s.remove();
    };
    var failed = function () {
      unspin();
      btn.disabled = true;
      btn.classList.add('is-gone');
      btn.setAttribute('aria-label', 'Unavailable');
      btn.title = 'Unavailable';
      btn.innerHTML = ICON_GONE + '<span class="hl-rel-add__t">Sold out</span>';
    };
    var done = function () {
      unspin();
      btn.classList.add('is-done');
      btn.innerHTML = ICON_TICK + '<span class="hl-rel-add__t">Added</span>';
      motion(btn, [{ transform: 'scale(.8)' }, { transform: 'scale(1.08)' }, { transform: 'none' }], 320);
    };
    var post = function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer-section',
          sections_url: window.location.pathname,
        }),
      }).then(function (r) { return r.json(); });
    };
    import('@shopify/events').then(function (m) {
      var E = m.CartLinesUpdateEvent;
      var deferred = E.createPromise();
      btn.dispatchEvent(new E({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: deferred.promise,
      }));
      return post().then(function (resp) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var bad = !!resp.status;
            deferred.resolve({
              cart: E.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'hl-cart-related',
                itemCount: 1,
                sections: bad ? undefined : resp.sections,
                didError: bad,
              },
            });
            if (bad) failed(); else done();
          });
      }).catch(function (err) {
        deferred.reject(err);
        unspin();
        btn.disabled = false;
      });
    }).catch(function () {
      // No import map (should not happen on this theme): the old swap.
      post().then(function (d) {
        if (d.status) { failed(); return; }
        var html = d.sections && d.sections['cart-drawer-section'];
        if (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner');
          var live = document.querySelector('#cart-drawer .cart-drawer__inner');
          if (fresh && live) live.replaceWith(fresh);
        }
        done();
        schedule();
      }).catch(function () { btn.disabled = false; });
    });
  }

  /* ---- MOTION, 2026-09-23 ------------------------------------------------
     Owner: "khi add to cart bằng relate products, animation cần như add to cart
     bth từ PDP, mượt và không được giật giật, nhất là đoạn chờ load thêm
     products, khi load thêm, height thay đổi, cần animation mượt".

     Recorded before this, adding from the rail: the rail vanished for 3.6s (the
     whole drawer inner was swapped, rail included), came back as a fresh box at
     card 1, and the tick on the button was never on screen. Adding from a sheet
     went through the theme's morph, which also drops the rail (it is not in the
     server HTML), and render() then rebuilt it 90ms later — a visible gap.

     So: ONE rail node for the life of the page. When a morph removes it, the
     observer puts the same node back in the same microtask — before paint, so
     there is no frame without it — with its cards and scroll position intact.
     Everything the shopper sees change is animated with transform/opacity only. */
  var railBox = null;      // the one rail node, kept across morphs
  var savedLeft = 0;       // track scroll position, survives a detach
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var EASE = 'cubic-bezier(.2,.7,.3,1)';
  function motion(node, frames, ms, delay) {
    if (reduce.matches || !node.animate) return null;
    try { return node.animate(frames, { duration: ms, delay: delay || 0, easing: EASE, fill: 'backwards' }); }
    catch (e) { return null; }
  }
  function fadeIn(nodes, dx) {
    for (var i = 0; i < nodes.length; i++) {
      motion(nodes[i], [
        { opacity: 0, transform: 'translateX(' + (dx || 0) + 'px)' },
        { opacity: 1, transform: 'none' }
      ], 260, i * 45);
    }
  }

  /* Put the rail where it belongs, synchronously. Cheap enough to run on every
     drawer mutation: it only writes when the node is detached or in the wrong
     seat. Returns true when it wrote. */
  function reseat(drawer) {
    if (!railBox) return false;
    var handles = cartHandles(drawer);
    if (!handles.length) {
      if (railBox.isConnected) railBox.remove();
      return false;
    }
    var seat = seatFor(drawer, handles.length);
    if (!seat) return false;
    var name = handles.length >= 2 ? 'I' : 'S';
    var placed = railBox.parentNode === seat.parent && railBox.nextElementSibling === seat.before;
    if (placed) return false;
    var moved = railBox.dataset.seat && railBox.dataset.seat !== name;
    railBox.classList.toggle('hl-rel--incart', name === 'I');
    railBox.dataset.seat = name;
    seat.parent.insertBefore(railBox, seat.before);
    var track = railBox.querySelector('.hl-rel__track');
    if (track && savedLeft) track.scrollLeft = savedLeft;
    // A seat change is a real move (summary -> end of the list at two lines):
    // it arrives rather than appears. A re-insert after a morph is invisible.
    if (moved) {
      motion(railBox, [
        { opacity: 0, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'none' }
      ], 280, 60);
    }
    return true;
  }

  /* AN <aside>, AND BOTH OF THE OBVIOUS REASONS FOR IT ARE WRONG. Read this
     before changing the tag a third time.

     The first reason given was a mispairing: morph.js's same() pairs elements on
     tagName alone unless BOTH carry a key, so a <div> here was predicted to be
     paired with .cart-actions and to push the subtotal and total off the end.
     MEASURED AND FALSE. tools/cart_morph_test.mjs reproduces the exact shape and
     the totals never disappear; they are removed and re-inserted either way,
     which is simply how this morph replaces that container.

     The second reason, once the first collapsed, was that the <aside> should go
     back because it costs extra churn — it makes the morph remove and re-add
     .cart-actions, the block holding the discount input, and a re-added node
     cannot keep what a shopper had typed. ALSO MEASURED, ALSO FALSE, AND IT IS
     BACKWARDS. tools/cart_discount_input_test.mjs types SAVE1 into the discount
     field and changes a line quantity, twice per build:

         as <aside>   removed: cart-actions, cart-totals__container, hl-rel
                      value KEPT ("SAVE1"), focus lost
         as <div>     removed: cart-totals__container
                      value LOST (""), focus lost

     The <aside> is the one that keeps the half-typed code. When .cart-actions is
     torn out and put back it is the SAME node going back, carrying its live
     value; when it is morphed in place the morph reconciles the input back to
     the server-parsed value — empty — and data-skip-node-update does not save it.
     Focus is lost either way, so the <div> buys nothing and costs the code.

     Reverted to <div> on instruction and restored on the measurement, which is
     the order those two things belong in. */
  function build() {
    var box = el('aside', 'hl-rel');
    box.id = 'hl-rel';
    box.innerHTML =
      '<p class="hl-rel__h" id="hl-rel-h">Pairs well with your order</p>' +
      '<div class="hl-rel__track" role="list" aria-labelledby="hl-rel-h"></div>';
    var track = box.querySelector('.hl-rel__track');
    track.appendChild(el('span', 'hl-rel-skel'));
    railBox = box;
    return box;
  }

  /* WHERE THE RAIL GOES DEPENDS ON HOW FULL THE CART IS, 2026-09-14.

     Owner: "them relate products o duoi cung (tren payments)" and then "neu nhu
     tren UI cart co >= 2 item doc lap => relate cart se duoc bo pin fixed duoi
     payent ma no se noi kem products list thanh mot cum".

     Two seats, one rule:

       ONE line item  -> first child of .cart-drawer__summary. The summary is the
                         block pinned to the bottom of the drawer, so the rail is
                         pinned with it, sitting directly above Estimated total
                         and the checkout and wallet buttons. With one product in
                         a tall drawer there is nothing but empty cream between
                         the line and the total, and this is what fills it.

       TWO OR MORE    -> last child of the scrolling item list, so it reads as
                         the end of the products rather than as a second block
                         bolted under the total. It scrolls away with them, which
                         is the "mot cum" (one cluster) the owner asked for, and
                         it stops the pinned block growing tall enough to crowd
                         the items it is meant to be under.

     The seat is recomputed on every pass because the count changes under the
     rail: remove the second product and it has to climb back into the summary. */
  function seatFor(drawer, count) {
    if (count >= 2) {
      var list = drawer.querySelector('.cart-drawer__items .cart-items__wrapper')
              || drawer.querySelector('.cart-drawer__items');
      if (list) return { parent: list, before: null };
    }
    var summary = drawer.querySelector('.cart-drawer__summary');
    if (summary) {
      var first = summary.firstElementChild;
      /* SKIP THE RAIL ITSELF. This line is why the rail would not scroll,
         2026-09-22. Once seated it IS summary.firstElementChild, so `before`
         became the box, and render()'s guard reduced to
         `box.nextElementSibling !== box` — true forever. Every observer pass
         therefore ran insertBefore(box, box), re-inserting a node that was
         already in the right place, and re-inserting a scroll container resets
         its scrollLeft to 0. Measured: a programmatic scrollLeft = 200 read back
         as 231 (snapped, so the track was scrollable all along) and was 0 again
         within 400ms. From a finger that is a rail that refuses to move and
         judders while it does it. */
      if (first && first.classList && first.classList.contains('hl-rel')) {
        first = first.nextElementSibling;
      }
      return { parent: summary, before: first };
    }
    return null;
  }


  /* A NEW SET REPLACES THE OLD ONE WITHOUT A HOLE: the old rows stay until the new
     set is known, fade out together, and the new ones come in behind them. */
  function swapCards(track, list) {
    var old = [].slice.call(track.children);
    var fromSkeleton = !old.length || track.querySelector('.hl-rel-skel');
    var fill = function () {
      track.innerHTML = '';
      list.forEach(function (p) { track.appendChild(card(p)); });
      fadeIn([].slice.call(track.children), fromSkeleton ? 0 : 12);
    };
    if (fromSkeleton || reduce.matches || !track.animate) { fill(); return; }
    var a = track.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 140, easing: 'ease-out' });
    a.onfinish = fill;
    a.oncancel = fill;
  }

  function render() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var handles = cartHandles(drawer);
    if (!handles.length) {
      if (railBox && railBox.isConnected) railBox.remove();
      /* an empty cart has no seed for recommendations: it shows a plain gallery of best sellers */
      if (isEmptyDrawer(drawer)) renderGallery(drawer); else removeGallery();
      return;
    }
    removeGallery();
    if (!railBox) { build(); railBox.hidden = true; }
    var box = railBox;
    reseat(drawer);

    var track = box.querySelector('.hl-rel__track');
    /* A refresh that arrives mid-fetch is re-queued, not dropped (a first open is
       morphed by the theme a moment after it renders). */
    if (busy) { pending = true; return; }
    busy = true;

    /* Every product in the cart contributes its pairings, the first line item's
       first; one product paired by two cart lines appears once; anything already in
       the cart is left out. Nothing paired -> the rail is not shown at all. */
    Promise.all(handles.map(fetchCombined)).then(function (lists) {
      var seen = {}, list = [];
      lists.forEach(function (l) {
        l.forEach(function (p) {
          if (seen[p.id] || !p.available || handles.indexOf(p.handle) !== -1) return;
          seen[p.id] = 1;
          list.push(p);
        });
      });
      list = list.slice(0, CARDS);
      if (!list.length) { box.hidden = true; track.dataset.hlKey = ''; return; }
      box.hidden = false;

      /* REBUILD ONLY WHEN THE SET CHANGED (the ids in order) — this is what keeps an
         open, untouched drawer at zero requests and keeps focus on a row. */
      var key = list.map(function (p) { return p.id; }).join(',');
      if (track.dataset.hlKey === key && !track.querySelector('.hl-rel-skel')) return;
      track.dataset.hlKey = key;
      swapCards(track, list);
    }).catch(function () {}).then(function () {
      busy = false;
      if (pending) { pending = false; schedule(); }
    });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 90); }

  function start() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return false;
    new MutationObserver(function (muts) {
      // Before anything else and before paint: a morph that just took the rail
      // out gets the same node back in this microtask.
      if (railBox && (!railBox.isConnected || !drawer.contains(railBox))) reseat(drawer);
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        // Our own writes. Without this the rail's own re-insert is a drawer
        // mutation, which schedules a render, which re-inserts.
        if (t && t.closest && t.closest('.hl-rel, .hl-gal')) continue;
        schedule();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });
    /* NOT schedule() HERE. This ran on load, so a shopper with a non-empty cart
       paid /products/<handle>.js and /recommendations on EVERY page view with the
       drawer shut — two requests for a rail nobody had asked to see. The first
       draw now waits for the drawer to actually open. The observer above still
       catches every later change, and the dialog's own [open] attribute is the
       signal, so nothing has to guess at the theme's event names. */
    var dlg = drawer.querySelector('dialog');
    if (dlg) {
      if (dlg.hasAttribute('open')) schedule();
      new MutationObserver(function () {
        if (dlg.hasAttribute('open')) schedule();
      }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    } else {
      schedule();
    }
    return true;
  }

  if (!start()) {
    var tries = 0;
    var iv = setInterval(function () { if (start() || ++tries > 20) clearInterval(iv); }, 300);
  }

  // The theme's own add path dispatches these; they are how "another item was
  // added" reaches this file without anything polling for it.
  document.addEventListener('cart:update', schedule);
  document.addEventListener('cart:lines:update', schedule);
})();
